import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=313680d8&scoped=true&"
import script from "./Diagnosis.vue?vue&type=script&lang=js&"
export * from "./Diagnosis.vue?vue&type=script&lang=js&"
import style0 from "./Diagnosis.vue?vue&type=style&index=0&id=313680d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313680d8",
  null
  
)

export default component.exports